import { makeStyles } from "@mui/styles";
import { colors, Commons } from "styleguide";

const styles = makeStyles({
  container: {
    border: `6px solid ${colors.orange}`,
    borderRadius: "18px !important",
    "& a": {
      color: colors.themeColor,
    },
  },
  buttonAux: {
    color: `${colors.gray50} !important`,
    flex: 1,
  },
  buttonCancel: {
    color: `${colors.orange} !important`,
    flex: 1,
  },
  buttonDone: {
    backgroundColor: `${colors.orange} !important`,
    color: `${colors.white} !important`,
    flex: 1,
  },
  rowButtons: {
    [Commons.smallQuery]: {
      flexDirection: "column",
      gap: 12,
      "& button": {
        width: "100%",
      },
    },
  },
});

export default styles;
